import { EpimsBaseEntityDto } from './epim-base.dto';
export class EncroachmentStatusDto extends EpimsBaseEntityDto {

    EncroachmentStatusId: string;

    EncroachmentStatusName: string;   

    SubscriptionUserId: string;

    Version: number; 
    length: number;
}